import logoUrl from '@/assets/iss-logo.png';
import { BRAND_NAME } from '@/i18n/dictionary';

/**
 * The Integrity Staffing Solutions wordmark, at the designed 240 × 47.12.
 *
 * The exact asset exported from Figma, committed rather than linked: the MCP asset URLs expire after about
 * seven days, so a remote reference would render a broken image in front of a candidate a week from now.
 *
 * Both dimensions are explicit. `h-auto` would let the intrinsic PNG size win at some breakpoints, and the
 * logo's own aspect ratio is not a round number.
 */
export function Logo() {
  return <img alt={BRAND_NAME} className="h-[47.12px] w-[240px] object-cover" src={logoUrl} />;
}
